import { Component, OnInit, ElementRef, OnDestroy, Optional } from '@angular/core';
//import { Component, OnInit, Optional, ElementRef, Input } from '@angular/core';
import { Observable, of, throwError } from 'rxjs';
import { AwardDTO, CompanyDocDTO, ContractDTO, ProcurementProjectDTO } from '../../../api/plyca-dtos-v2';
import { BaseFormComponent, BaseFormHeaderInfo } from '../../baseFormComponent/baseForm.component';
import { FormConfig } from '../../../components/forms/form.objects';
import { TaskDTO, SearchResultDTO, ProcedureDTO, getParentIdentifierFromString, getSimpleIdentifierFromString, normalizaDossierId } from '../../../api/plyca-dtos';
import { LotState, LotStateInfoDTO, ProcurementProjectLotStateInfoDTO } from '../model/procurementProjectLotStateInfo.model';
import * as lodash from 'lodash';
import { DynamicDialogRef, DynamicDialogConfig, DialogService } from 'primeng-lts/dynamicdialog';
import { UIService, generateRandomIdentifier } from '../../../ui.service';
import { catchError, finalize, tap, take, switchMap, mergeMap, map } from 'rxjs/operators';
import { ResultTypeDTO, ValidationResultDTO, ValidationResultDTOError } from '../../../api/plyca-dtos-v2';
import { AppConfiguration } from '../../../conf/app.configuration';
import { PlycaErrorHandler } from '../../../../http/PlycaErrorHandler';
import { UserService } from '../../../user.service';
import { BaseProjectEntityDTO } from '../../../api/sarga-dtos';
import { HelpService, HelpType } from '../../../components/common/help/help.service';

export class ProcurementProjectLotStateInfoModel {

  dto: ProcurementProjectLotStateInfoDTO;
  ui: {
    awardColVisible?: boolean,
    desertColVisible?: boolean,
    isSupportProfile?: boolean,
    isReportDesertLot?: boolean,
    lotesProcesados?: LotStateInfoDTO[],
    lotesPdtesComunicar?: Array<LotStateInfoDTO>,
    isTask?: boolean,
    normalizedDossierId?: string;
  };
}

@Component({
  //selector: 'lotStateInfoModel',
  templateUrl: '../../baseFormComponent/baseForm.template.html'
  //templateUrl: '../../../dossiers/registerContractModifications/registerContractModification.template.html',
  //providers: [ProjectOrganizationalSnapshotValidations]
  //\app\dossiers\registerContractModifications\registerContractModification.template.html
  //\app\tasks\receipt\component\receipt.component.ts
})

export class ProcurementProjectLotStateInfoComponent extends BaseFormComponent<ProcurementProjectLotStateInfoDTO, ProcurementProjectLotStateInfoModel>
  implements OnInit, OnDestroy {
  private paramProject: ProcurementProjectDTO;
  isModal: boolean;
  tagsParent: string[];

  constructor(
    @Optional() protected dialogConfig: DynamicDialogConfig,
    protected appConfig: AppConfiguration,
    private plycaErrorHandler: PlycaErrorHandler,
    private userService: UserService,
    public helpService: HelpService,
    elem: ElementRef) {
    super(elem);

    // Se declara en el constructor, con esto se instancia!!
    //this.userService = ServiceLocator.injector.get(UserService);
    this.isModal = false;
    if (this.dialogConfig) {
      if (this.dialogConfig['action']) { // Se abre la pantalla mediante una action desde la gestión de expedientes en AYMAD
        this.isModal = true;
        this.windowHash = generateRandomIdentifier();
        this.paramProject = this.dialogConfig['dto'];
      } else if (this.dialogConfig.data) { // Se abre la pantalla desde otra pantalla
        this.isModal = true;
        this.windowHash = generateRandomIdentifier();
        // OFERTAS
        //this.paramProject = this.dialogConfig.data.project;
        //this.paramTenderClassificationType = this.dialogConfig.data.tenderClassificationType;
      } else {
        // **********************************************************************
        //Pasa por aqui cuando es tarea, nocalculamos el  windowHash
        // *********************************************************************
      }

      /*if (this.isModal) {
        this.subscribe(this.helpService.getStoreTagsObservable().pipe(
          switchMap(
            (storedHelpTags) => {
              this.tagsParent = storedHelpTags;
              return this.helpService.showContextHelpObservable(HelpType.PROCUREMENTPROJECT_LOT_STATE_INFO_CONSULT)
            }
          )));
        this.windowHash = generateRandomIdentifier();
      } else {
        this.subscribe(
          this.helpService.showContextHelpObservable(HelpType.PROCUREMENTPROJECT_LOT_STATE_INFO_CONSULT));
      }*/
    }
  }

  configureFormConfig(formConfig: FormConfig): Observable<FormConfig> {
    //Esto es para cargar las funciones del formulario
    if (this.isModal) {
      formConfig.searchTags = [HelpType.PROCUREMENTPROJECT_LOT_STATE_INFO_CONSULT];
      formConfig.isModalWindow = true;
      formConfig.windowHash = this.windowHash;
      formConfig.readonly = true;
    }
    //formConfig.showValidations = true;
    this.loadFunctions(formConfig);
    return super.configureFormConfig(formConfig);
    /*formConfig.functions.push({
      identifier: 'isVacio',
      fn: this.isVacio.bind(this)
    });
    formConfig.functions.push({
      identifier: 'loadOrganizationalSnapshotData',
      fn: this.loadOrganizationalSnapshotData
    });
    formConfig.functions.push({
      identifier: 'changeProjectOrganizationalSnapshot',
      fn: this.changeProjectOrganizationalSnapshot
    });
    return of(formConfig);*/
  }

  //Funciones
  loadFunctions(_formConfig: FormConfig) {
    _formConfig.functions.push({
      identifier: 'isStatePdteAdjudicar',
      fn: this.isStatePdteAdjudicar.bind(this)
    });
    _formConfig.functions.push({
      identifier: 'isStatePdteDesierto',
      fn: this.isStatePdteDesierto.bind(this)
    });
    _formConfig.functions.push({
      identifier: 'onChangeMarkedForAwardLot',
      fn: this.onChangeMarkedForAwardLot.bind(this)
    });

    _formConfig.functions.push({
      identifier: 'onChangeMarkedForDesertLot',
      fn: this.onChangeMarkedForDesertLot.bind(this)
    });
  }


  ngOnInit(): void {
    super.ngOnInit();
  }

  public getDossierId(): string {
    // 1 apertura tarea
    let dossierId = (this.task) ? this.task.division.project.identifier : '';

    // 2 apertura en modal
    // (contratacion)
    // Desde Ofertas
    if (!dossierId) {
      dossierId = (this.paramProject) ? this.paramProject.identifier : '';
    }
    /*
     3 apertura en modal (reco)
    if (!dossierId && this.dialogConfig.data.project.division) {
      dossierId = this.dialogConfig.data.project.division.project.identifier;
    }
    // 4 apertura en modal (contratacion)
    if (!dossierId) {
      dossierId = this.dialogConfig.data.project.identifier;
    }*/

    return dossierId;
  }

  loadObs(procurementProjectLotStateInfoModel: ProcurementProjectLotStateInfoModel): Observable<ProcurementProjectLotStateInfoModel> {
    let obs: Observable<ProcurementProjectLotStateInfoModel>;
    let dossierId = this.getDossierId();
    let params = new Map<string, string>();
    //params.set('PROPUESTAID', this.normalizaDossierId(this.model.identifier));
    params.set('PROPUESTAID', dossierId);
    //this.subscribe(
    obs = this.plycaService.getSearchSetting('LOT_STATE_INFO_SEARCH').pipe(
      mergeMap(
        (def: any) =>
          this.plycaService
            .getResultSearchSetting(
              def.links[0].href + '/values?',
              params
            )
      ),
      map(
        (result: SearchResultDTO) => {
          console.log(result);
          let listLotStateInfo: LotStateInfoDTO[] = [];
          //if (result?.content) {
          //listLotStateInfo.push(result?.content);

          result?.content?.forEach((obj) => {
            let lotStateInfo = obj?.singleValue;
            listLotStateInfo.push(lotStateInfo);

          });

          //let procurementProjectLotStateInfo: ProcurementProjectLotStateInfoDTO;
          procurementProjectLotStateInfoModel.dto.allLotsAllStateInfo = listLotStateInfo;
          return procurementProjectLotStateInfoModel;
        }
      )
    );
    return obs;
  }

  getHeaderInfo(): BaseFormHeaderInfo {
    let headerInfo = new BaseFormHeaderInfo();
    headerInfo.titleKey = this.getTitle();
    headerInfo.titleIcon = 'fas fa-file-invoice';
    if (this.task?.work) {
      headerInfo.titleIcon = 'fas fa-hand-holding';
    }
    /* if (this.model && this.model.dto && this.model.dto.division && this.model.dto.division.project) {
       headerInfo.project = this.model.dto.division.project;
     }*/
    return headerInfo;
  }

  getTitle(): string {
    let msg = 'Estado actual de los lotes del expediente';
    if (this.task?.work) {
      msg = 'Indicar Lotes';
      if (this.task?.work?.context?.configurations?.isReportDesertLot?.value) {
        msg = 'Indicar Lotes para comunicar';
      }
    }
    return msg;
  }


  ngOnDestroy(): void {
    this.dialogConfig = null;
    this.dialogService = null;
    if (this.isModal) {
      this.headerActionsService.clearWindowActions(this.windowHash);
      /*this.subscribe(this.helpService.showContextHelpObservable(this.tagsParent).pipe(
        finalize(() => {
          super.ngOnDestroy();
        })));*/
    } else {
      this.headerActionsService.clearActions();
    }
    super.ngOnDestroy();
  }


  getFormSettingURL(): string {
    return 'procurementProjectLotStateInfo/procurementProjectLotStateInfo.json';
  }
  getServiceURL(): string {
    return undefined;
  }
  getObjectIdentifier() {
    return undefined;
  }
  dtoToModel(dto: ProcurementProjectLotStateInfoDTO): Observable<ProcurementProjectLotStateInfoModel> {

    let model = new ProcurementProjectLotStateInfoModel();

    // Iniciamos el ui
    model.ui = {
      lotesPdtesComunicar: new Array<LotStateInfoDTO>(),
      lotesProcesados: [],
      isReportDesertLot: false,
      isSupportProfile: false,
      isTask: false
    };

    if (this.task?.work) {
      model.dto = this.task.work['procurementProjectLotStateInfo'];
      if (model.dto) {
        model.ui.isTask = true;
      }
      // model.ui.awardColVisible = !this.isModal;
    } else {
      dto = {} as ProcurementProjectLotStateInfoDTO;
      dto.procurementProject = this.paramProject;
      model.dto = dto;
    }

    model.ui.normalizedDossierId = normalizaDossierId(this.getDossierId());

    let supportProfile = this.appConfig.getValue('user.supportProfile');
    model.ui.isSupportProfile = this.userService.hasRoles(supportProfile);

    //ID_SISTCOMPLEMENTARIO  -> ProcurementProjectDTO:classification.complementarySystem
    //AM =  expediente.getIdSistComplementario().equals("AM");
    /*if(!AM){
      vColumnasTabla.addElement(controlTextos.getString("COLUMNA_LOTE_PRESUPUESTO"));
    }else{
      vColumnasTabla.addElement(controlTextos.getString("COLUMNA_LOTE_VALOR_ESTIMADO"));
    }*/



    let modelObs: Observable<ProcurementProjectLotStateInfoModel>;
    if (this.task?.work) {
      if (this.task?.work?.context?.configurations?.isReportDesertLot?.value) {
        model.ui.isReportDesertLot = true;
      }
      model.ui.lotesPdtesComunicar = model.dto.workToDoLotsStateInfo;
      model.ui.lotesProcesados = model.dto.processedLotsStateInfo;
      this.setColumnCompanyDoc(model);
      modelObs = of(model)
    } else {
      modelObs = this.loadObs(model);

      this.waitService.startWaiting();
      // ****************************************************************************************************************
      // Importante, la siguiente linea devuelve otro observable por tanto deberíamos volver a reasignar la variable:
      //        KO -> modelObs.pipe(tap(...
      //        OK -> modelObs = modelObs.pipe(tap(...
      // La otra opción es hacer un return del propio observable
      // ****************************************************************************************************************
      let self = this;
      modelObs = modelObs.pipe(
        //  *************************************************************************************************************
        // Para poder acceder al this de la clase dentro del tap tenemos dos formas:
        // La primera: Definiendo let self = this fuera y haciendo referencia a self dentro del tap
        // La segunda: Definiendo una function a la que le establecemos el bind
        //  *************************************************************************************************************
        /*tap(function (procurementProjectLotStateInfoModel: ProcurementProjectLotStateInfoModel) {
          // EL buscador de vuelve los lotes del expediente, pero no los clasifica.
          if (model.ui.isReportDesertLot) {
            procurementProjectLotStateInfoModel.ui.lotesPdtesComunicar = procurementProjectLotStateInfoModel.dto.allLotsAllStateInfo.
              filter(lotStateInfo =>
                lotStateInfo.procurementProjectLot.state == LotState.COMUNICADO_DESIERTO
                || lotStateInfo.procurementProjectLot.state == LotState.DESIERTO);
          } else {
            procurementProjectLotStateInfoModel.ui.lotesPdtesComunicar = procurementProjectLotStateInfoModel.dto.allLotsAllStateInfo.
              filter(lotStateInfo =>
                lotStateInfo.procurementProjectLot.state == LotState.PENDIENTE_ADJUDICAR
                || lotStateInfo.procurementProjectLot.state == LotState.EN_TRAMITACION);
            procurementProjectLotStateInfoModel.ui.lotesProcesados = procurementProjectLotStateInfoModel.dto.allLotsAllStateInfo.
              filter(
                lotStateInfo => lotStateInfo.procurementProjectLot.state == LotState.ADJUDICADO
                  || lotStateInfo.procurementProjectLot.state == LotState.DESIERTO
                  || lotStateInfo.procurementProjectLot.state == LotState.COMUNICADO_DESIERTO);
          }
          this.setColumncompanyDoc(procurementProjectLotStateInfoModel);
        }.bind(this))*/

        tap((procurementProjectLotStateInfoModel: ProcurementProjectLotStateInfoModel) => {
          // Cuando no esta tarea. El buscador devuelve los lotes del expediente, pero no los clasifica.
          procurementProjectLotStateInfoModel.ui.lotesPdtesComunicar = procurementProjectLotStateInfoModel.dto.allLotsAllStateInfo.
            filter(lotStateInfo =>
              lotStateInfo.procurementProjectLot.state === LotState.PENDIENTE_ADJUDICAR
              || lotStateInfo.procurementProjectLot.state === LotState.EN_TRAMITACION);
          procurementProjectLotStateInfoModel.ui.lotesProcesados = procurementProjectLotStateInfoModel.dto.allLotsAllStateInfo.
            filter(
              lotStateInfo => lotStateInfo.procurementProjectLot.state === LotState.ADJUDICADO
                || lotStateInfo.procurementProjectLot.state === LotState.DESIERTO
                || lotStateInfo.procurementProjectLot.state === LotState.COMUNICADO_DESIERTO);
          self.setColumnCompanyDoc(procurementProjectLotStateInfoModel);
        }),
        catchError((error: any) => {
          this.waitService.cancelWaiting();
          this.plycaErrorHandler.showServerError(error);
          return throwError(error);
        }),
        finalize(() => this.waitService.cancelWaiting())
      );
    }
    return modelObs;
  }

  setColumnCompanyDoc(procurementProjectLotStateInfoModel: ProcurementProjectLotStateInfoModel) {
    procurementProjectLotStateInfoModel?.ui?.lotesProcesados?.forEach((obj) => {
      if (obj?.procurementProjectLot?.state == LotState.DESIERTO || obj?.procurementProjectLot?.state == LotState.COMUNICADO_DESIERTO) {
        obj.award.companyDoc.taxIdentifier = '';
        if (obj.award === undefined) {
          let adward = new AwardDTO();
          let companyDoc = new CompanyDocDTO();
          adward.companyDoc = companyDoc;
          obj.award = adward;
        }
        if (obj?.procurementProjectLot?.state == LotState.DESIERTO) {
          obj.award.companyDoc.name = 'DESIERTO';
        } else if (obj?.procurementProjectLot?.state == LotState.COMUNICADO_DESIERTO) {
          obj.award.companyDoc.name = 'DESIERTO(COMUNICADO DESIERTO)';
        }
      }
    });
  }
  modelToDTO(model: ProcurementProjectLotStateInfoModel): ProcurementProjectLotStateInfoDTO {

    /*this.model.dto.workToDoLotsStateInfo = this.model.ui.lotesPdtesComunicar.filter(lotStateInfo =>
      lotStateInfo.procurementProjectLot.state == LotState.PENDIENTE_ADJUDICAR);*/

    let cleanModel = JSON.parse(
      JSON.stringify(model.dto, (k, v) => (k === '_parent' ? undefined : v))
    );
    return cleanModel;
  }

  // TODO
  protected updateTask(updatedTask: TaskDTO) {
    this.formService.merge(this.task, updatedTask);
  }

  protected setTaskReference2(modifiedDto: any) {
    if (this.task) {
      // en el caso de tareas con recursos se envía la referencia a la tarea
      // para que el servidor obtenga las variables de contexto de la misma
      modifiedDto.task = {} as TaskDTO;
      modifiedDto.task.identifier = this.task.identifier;
    }
  }

  initHeaderActions() {
    this.headerActionsService.clearWindowActions(this.windowHash);
    this.subscribe(this.headerActionsService
      .addWindowAction(
        'General.accept',
        'fas fa-lg fa-check',
        'btn-primary',
        true,
        this.windowHash
      ),
      success => {
        //this.modelToDTO(lodash.cloneDeep(this.model));
        //this.formService.merge(this.task, updatedTask);
        //this.setTaskReference2(this.task);
        //this.updateTask
        //this.saveWorkObservable
        //this.updateTask(updatedTask: TaskDTO) {
        this.processTask();
        //this.saveIfValid
        ///this.subscribe(this.saveIfValid());
      });
    this.headerActionsService.addDivider();
    this.addBackAction();
  }

  isVacio(model: any) {
    console.log('EJECUTADO isVacio', model);
    return false;
  }

  // Funciones del formulario
  public isStatePdteAdjudicar(model: any): boolean {
    if (model?.procurementProjectLot?.state == LotState.PENDIENTE_ADJUDICAR) {
      return true;
    }
    return false;
  }

  public isStatePdteDesierto(model: any): boolean {
    // El model que entra como parametro es LotStateInfoDTO
    if (this.model.ui.isReportDesertLot) {
      if (model?.procurementProjectLot?.state != LotState.COMUNICADO_DESIERTO) {
        // Así se hace en el applet. Aunque su estado sea DESIERTO se permite modificar, solo se controla cuando es COMUNICADO_DESIERTO
        return true;
      }
    } else {
      if (model?.procurementProjectLot?.state == LotState.PENDIENTE_ADJUDICAR) {
        return true;
      }
    }
    return false;
  }

  COMUNICADO_DESIERTO

  public onChangeMarkedForDesertLot(model: LotStateInfoDTO, changes?: any) {
    if (changes.newValue) {
      model.markedForAwardLot = false;
    }
  }

  public onChangeMarkedForAwardLot(model: LotStateInfoDTO, changes?: any) {
    if (changes.newValue) {
      model.markedForDesertLot = false;
    }
  }
}